module.exports = {
	"header": "Contact Us",
	"generalInformation": "General Information",
	"headerSmall": "How to reach $t(general::brand)",
	"sales": "Sales",
	"support": "Support",
	"messageSent": "Message sent!",
	"paragraph1": "We're happy to answer any questions or provide you with assistance for using our services. Just message us using the form below with any question you may have in mind.",
	"errors": {
		"noEmail": "$t(errors::user.emailRequired)",
		"noMessage": "You need to put in some message for us!",
		"noName": "You need to provide a contact name.",
		"noType": "You need to provide a valid inquiry type.",
		"noSubject": "You need to put in a subject for your inquiry.",
		"sendingMessage": "Error while sending the message."
	},
	"address": "Address",
	"email": "E-mail",
	"emailPlaceholder": "Enter your e-mail address",
	"inquiryTypes": {
		"0": "Sales",
		"1": "Technical Support",
		"2": "Billing",
		"3": "Marketing and PR"
	},
	"message": "Message",
	"messagePlaceholder": "Your message for us...",
	"namePlaceholder": "Enter your name",
	"phone": "Phone",
	"typeOfInquiry": "Type of inquiry",
	"subject": "Subject",
	"subjectPlaceholder": "Subject of your inquiry",
	"submit": "Submit",
	"supportDays": "Monday to Friday",
	"supportHours": "8 AM to 6 PM - Eastern Time",
	"tollFree": "Toll-free",
	"confirmationMessage": {
		"header": "Contact inquiry confirmation",
		"paragraph1": "We have received your contact inquiry. A representative will contact you shortly and gladly answer all your questions."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/contact.json5
// module id = 1924
// module chunks = 6